import { Button, Card, Grid, IconButton } from '@material-ui/core';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import { useSelector } from 'react-redux';
import { FormBox } from './FormBox';
import DeleteButtonAbm from '../../../compartidos/abms/DeleteButtonAbm';
import { GenericModal } from '../../../atomic/organisms/GenericModal';
import { useTotemBasic } from '../../../../hooks/useCases/useTotemBasic';
import { useEffect, useState } from 'react';
import { Pageview } from '@material-ui/icons';

export const AbmBox = () => {
    const [modalBox, setModalBox] = useState({ open: false, box: null })
    const { boxes } = useSelector(state => state.totemBasic)
    const { get, remove } = useTotemBasic()
    useEffect(() => get.boxes(), [])
    return (
        <>
            <GenericModal open={modalBox.open} title={modalBox.box ? "MODIFICAR BOX" : "AGREGAR BOX"} closeModal={() => setModalBox({ ...modalBox, open: false })} maxWidth='sm'>
                <FormBox box={modalBox.box} closeModal={() => setModalBox({ ...modalBox, open: false })} />
            </GenericModal>
            <Grid container spacing={2} justify='center' style={{ padding: 10, marginTop: 2 }}>
                <Grid item xs={9} style={{ display: "flex", justifyContent: "flex-end", paddingRight: 10 }}>
                    <Button variant="contained" color='primary' onClick={() => setModalBox({ open: true, box: null })}>
                        + AGREGAR BOX
                    </Button>
                </Grid>
                <Grid item xs={9} component={Card} >
                    <TableGeneric
                        data={boxes}
                        columns={[
                            {
                                label: "Id",
                                id: "id",
                            },
                            {
                                label: "Descripcion",
                                id: "descripcion",
                            },
                            {
                                label: "",
                                customBody: (item) => (
                                    <>
                                        <IconButton
                                            aria-label="Editar"
                                            onClick={() => setModalBox({ open: true, box: item })}
                                        >
                                            <Pageview sx={{ fontSize: "2rem" }} color="primary" />
                                        </IconButton>
                                        <DeleteButtonAbm
                                            permiso={null}
                                            handleDelete={() => remove.box({id: item.id})}
                                            mensajeEliminacion={`¿Estás seguro que deseas eliminar el box "${item.descripcion}"?`}
                                        />
                                    </>
                                )
                            },
                        ]}
                    />
                </Grid>
            </Grid>
        </>
    )
}
